import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    input: {
        marginBottom: 16
    },
    detailsRow: {
        display: 'flex',
        marginBottom: 10,
        alignItems: 'center'
    },
    detailsNameColumn: {
        flex: 1,
        color: theme.quaternary,
        fontWeight: 'bold'
    },
    modalButtons: {
        marginTop: 20,
        display: 'flex',
        gap: 15,
        justifyContent: 'flex-end'
    },
    select: {
        marginBottom: 16
    },
    section: {
        marginTop: 16
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    textareaSection: {
        display: 'flex',
        backgroundColor: `${theme.background}`,
        marginTop: '2%'
    },
    textareaInput: {
        // minHeight: '120px',
        borderRadius: theme.borderRadius,
        flex: 1,
        width: '30%',
        '& div': {
            background: `${theme.background} !important`
        }
    },
    saveButton: {
        justifyContent: 'center',
        alignItems: 'center',
        '& span': {
            marginRight: 0
        }
    },
    buttonsWrapper: {
        width: '50%',
        marginLeft: 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        marginBottom: '15px'
    },
    commentSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '15px'
    },
    commentCardWrapper: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: '0 10px',
        '-webkit-box-shadow': '0px 0px 5px 0px rgba(179,179,179,1)',
        '-moz-box-shadow': '0px 0px 5px 0px rgba(179,179,179,1)',
        boxShadow: '0px 0px 5px 0px rgba(179,179,179,1)',
        borderRadius: theme.borderRadius,
        minHeight: 200
    },
    commentInfo: {
        flex: 1,
        marginBottom: '10px'
    },
    commentContentSection: {
        marginTop: '15px',
        marginBottom: '10px'
    },
    commentButtonSection: {
        display: 'flex',
        marginLeft: 'auto',
        marginBottom: '15px'
    },
    dateTimeComment: {
        color: 'gray',
        fontSize: '12px',
        marginTop: '3px'
    }
}))
